import { useQuery } from "@tanstack/react-query";
import { getLoyaltyProgamList } from "../../service/query/auth";



export const useGetLoyaltyProgram = () => {
  const getLoyaltyProgram = useQuery({
    queryKey: ["loyalProgram"],
    queryFn: getLoyaltyProgamList,
    enabled: true,
    keepPreviousData: true,
  });
  return { data: getLoyaltyProgram?.data?.data, ...getLoyaltyProgram };
};
